export enum UNITS {
  REPETITION = 'RP',
  MINUTES = 'MI',
  SECONDS = 'SE',
  METERS = 'MT',
}
